import { useState } from 'react';

const portfolioItems = [
  {
    image: 'https://ziersteine.de/wp-content/uploads/2019/02/slider-arabella.jpg',
    title: 'Arabella Vorgarten',
    subtitle: 'Italien · Marmor',
    tag: 'Edelsplitt',
  },
  {
    image: 'https://ziersteine.de/wp-content/uploads/2019/02/slider-jura-kalkstein.jpg',
    title: 'Jura Kalkstein Anlage',
    subtitle: 'Deutschland · Kalkstein',
    tag: 'Gabionensteine',
  },
  {
    image: 'https://ziersteine.de/wp-content/uploads/2019/02/slider-rouge-royal.jpg',
    title: 'Rouge Royal Garten',
    subtitle: 'Griechenland · Marmor',
    tag: 'Dekosteine',
  },
  {
    image: 'https://ziersteine.de/wp-content/uploads/2019/02/slider-glanzkies-tiger-eye.jpg',
    title: 'Tiger Eye Terrasse',
    subtitle: 'China · Kalkstein-gelackt',
    tag: 'Edelsplitt',
  },
  {
    image: 'https://ziersteine.de/wp-content/uploads/2019/02/slider-kristall-gelb.jpg',
    title: 'Kristall Gelb Beet',
    subtitle: 'Italien · Marmor',
    tag: 'Dekosteine',
  },
  {
    image: 'https://ziersteine.de/wp-content/uploads/2019/02/slider-canadian-slate-green.jpg',
    title: 'Canadian Slate Weg',
    subtitle: 'Großbritannien · Schiefer',
    tag: 'Gabionensteine',
  },
];

const filters = ['Alle', 'Edelsplitt', 'Gabionensteine', 'Dekosteine'];

export default function PortfolioSection() {
  const [activeFilter, setActiveFilter] = useState('Alle');
  const [lightbox, setLightbox] = useState<null | typeof portfolioItems[0]>(null);

  const filtered =
    activeFilter === 'Alle'
      ? portfolioItems
      : portfolioItems.filter((p) => p.tag === activeFilter);

  return (
    <section id="portfolio" className="bg-white py-32 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-10 gap-4">
          <div>
            <span className="px-4 py-1 rounded-full border border-stone-300 text-stone-500 text-xs tracking-widest uppercase mb-4 inline-block">
              Portfolio
            </span>
            <h2
              className="font-light text-stone-900"
              style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', fontFamily: "'Playfair Display', serif" }}
            >
              Referenzprojekte
            </h2>
          </div>
          <p className="text-stone-500 text-sm max-w-xs leading-relaxed">
            Ausgewählte Arbeiten aus über 25 Jahren Natursteingestaltung
          </p>
        </div>

        {/* Filters */}
        <div className="flex gap-3 mb-12 flex-wrap">
          {filters.map((f) => (
            <button
              key={f}
              onClick={() => setActiveFilter(f)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                activeFilter === f
                  ? 'bg-stone-900 text-white'
                  : 'bg-stone-100 text-stone-600 hover:bg-stone-200'
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((item, i) => (
            <div
              key={item.title + i}
              className="group relative rounded-2xl overflow-hidden cursor-pointer"
              style={{ height: '340px' }}
              onClick={() => setLightbox(item)}
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="absolute top-4 right-4">
                <span className="bg-white/20 backdrop-blur-sm text-white text-xs px-3 py-1 rounded-full border border-white/30">
                  {item.tag}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                <p className="text-white font-semibold text-lg">{item.title}</p>
                <p className="text-white/60 text-sm mt-1">{item.subtitle}</p>
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full border border-white/40">
                  <i className="ri-zoom-in-line text-white text-lg" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-6"
          onClick={() => setLightbox(null)}
        >
          <div
            className="relative max-w-3xl w-full rounded-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={lightbox.image}
              alt={lightbox.title}
              className="w-full h-auto object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent">
              <p className="text-white font-semibold text-xl">{lightbox.title}</p>
              <p className="text-white/60 text-sm">{lightbox.subtitle}</p>
            </div>
            <button
              onClick={() => setLightbox(null)}
              className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full text-white cursor-pointer transition-colors"
            >
              <i className="ri-close-line text-lg" />
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
